<template>
	<div class="filter-bar" :class="classes">
    <div class="filter-bar--breadcrumb">
      <li><a href="/">{{$store.getters.language.home}}</a></li>
      <li>
        <svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.191434 9.84396C-0.0475602 9.62106 -0.0651732 9.24159 0.152094 8.99639L3.69331 5L0.152095 1.00361C-0.0651731 0.758412 -0.0475601 0.378944 0.191434 0.15604C0.430429 -0.0668642 0.800303 -0.0487938 1.01757 0.196401L4.79721 4.46186C5.0676 4.767 5.0676 5.233 4.79721 5.53814L1.01757 9.8036C0.800303 10.0488 0.430429 10.0669 0.191434 9.84396Z" fill="#7A7A7A"/>
        </svg>
      </li>
      <li><router-link to="/search">{{$store.getters.language.rent}}</router-link></li>
      <li v-if="$route.name === 'Centre'">
        <svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.191434 9.84396C-0.0475602 9.62106 -0.0651732 9.24159 0.152094 8.99639L3.69331 5L0.152095 1.00361C-0.0651731 0.758412 -0.0475601 0.378944 0.191434 0.15604C0.430429 -0.0668642 0.800303 -0.0487938 1.01757 0.196401L4.79721 4.46186C5.0676 4.767 5.0676 5.233 4.79721 5.53814L1.01757 9.8036C0.800303 10.0488 0.430429 10.0669 0.191434 9.84396Z" fill="#7A7A7A"/>
        </svg>
      </li>
      <li v-if="$route.name === 'Centre'"><router-link :to="$route.path">{{ spaceTitle }}</router-link></li>
    </div>
		<div class="filter-bar--scroll">
			<a @click.prevent="resetFilters()" href="#" class="filter-bar--reset" :class="filterHasValue ? 'is--enabled' : null">{{$store.getters.language.RESET_FILTERS}}</a>
      <hr class="filter-bar--separator" />
			<div class="filter-bar--input-group" :class="disabled && disabled.includes('location') ? 'filter-bar--input-group--disabled' : null">
				<div class="filter-bar--label">{{$store.getters.language.LOCATION}}</div>
				<TypeSearch></TypeSearch>
			</div>
      <hr class="filter-bar--separator" />
      <div class="filter-bar--input-group">
				<div class="filter-bar--label">{{$store.getters.language.DATES}}</div>
				<DatePicker :data="searchResults" :values="returnDateRange" />				
			</div>
			<div class="filter-bar--input-group">
				<div class="filter-bar--label">{{$store.getters.language.PRICE}}</div>
				<div class="filter-bar--input--two-up">
          <Input @click="showPricePopup = !showPricePopup" :placeholder="$store.getters.language.FROM" :value="$store.state.rent.from_price !== null ? $store.state.rent.from_price : null" />
          <Input @click="showPricePopup = !showPricePopup" :placeholder="$store.getters.language.TO" :value="$store.state.rent.to_price !== null ? $store.state.rent.to_price : null" />
          <RangePopup v-if="showPricePopup" @close="showPricePopup = false" @input="commitValue(Number($event[0]), 'from_price'), commitValue(Number($event[1]), 'to_price')" :data="returnPrice.data" :marks="returnPrice.marks" :min="returnPrice.min" :max="returnPrice.max" :from="returnPrice.from" :to="returnPrice.to" :label="$store.getters.language.daily_rate"></RangePopup>
			   </div>
			</div>
			<div v-if="organisation_name == 'Nhood'" class="filter-bar--input-group" :class="disabled && disabled.includes('footfall') ? 'filter-bar--input-group--disabled' : null">
				<div class="filter-bar--label">{{$store.getters.language.FOOTFALL}}</div>
				<div class="filter-bar--input--two-up">
          <Input @click="showFootfallPopup = !showFootfallPopup" :placeholder="$store.getters.language.FROM" :value="$store.state.rent.from_footfall !== null ? $store.state.rent.from_footfall : null" />
          <Input @click="showFootfallPopup = !showFootfallPopup" :placeholder="$store.getters.language.TO" :value="$store.state.rent.to_footfall !== null ? $store.state.rent.to_footfall : null" />
          <RangePopup v-if="showFootfallPopup" @close="showFootfallPopup = false" @input="commitValue(Number($event[0]), 'from_footfall'), commitValue(Number($event[1]), 'to_footfall')" :data="returnFootfall.data" :marks="returnFootfall.marks" :min="returnFootfall.min" :max="returnFootfall.max" :from="returnFootfall.from" :to="returnFootfall.to" :label="($store.getters.language.footfall + $store.getters.language.per_week2)"></RangePopup>
				</div>
		  </div>
      <hr v-if="organisation_name != 'Nhood'" class="filter-bar--separator" />
			<div v-if="organisation_name != 'Nhood'" class="filter-bar--input-group" :class="disabled && disabled.includes('property_type') ? 'filter-bar--input-group--disabled' : null">
				<div class="filter-bar--label">{{$store.getters.language.PROPERTY_TYPE}}</div>
				<CheckboxGroup @input="commitValue($event, 'category_id')"
					:values="returnPropertyType"
				 />
			</div>
      <hr class="filter-bar--separator" />
			<div class="filter-bar--input-group">
				<div class="filter-bar--label">{{$store.getters.language.SPACE_TYPE}}</div>
				<CheckboxGroup @input="commitValue($event, 'amenity_id')"
					:values="returnAmenity"
				 />
			</div>
      <div class="filter-bar--input-group">
        <div class="filter-bar--label">Space Amenities</div>
        <Input @click="showFeaturePopup = !showFeaturePopup" :placeholder="null" :value="$store.state.rent.feature_id && $store.state.rent.feature_id.length > 0 ? $store.state.rent.feature_id : null" />
        <FeaturePopup v-if="showFeaturePopup" :data="returnFeatures" @close="showFeaturePopup = false"></FeaturePopup>
      </div>
		</div>
	</div>
</template>

<script>
import gql from 'graphql-tag'

import Input from "./filters/Input"
import DatePicker from "./filters/DatePicker"
import Select from "./filters/Select"
import Checkbox from "./filters/Checkbox"
import CheckboxGroup from "./filters/CheckboxGroup"
import Range from "./filters/Range"
import RangePopup from "./filters/RangePopup"
import TypeSearch from "../../components/search/TypeSearch"
import FeaturePopup from "./filters/FeaturePopup"
import axios from "axios";

export default {
  name: 'FilterBar',
  data: () => ({
    typeSearchResults: null,
    showPricePopup: false, 
    showFootfallPopup: false,
    showFeaturePopup: false,
    organisation_name: 'Fillit'
  }),
  props: ['searchResults', 'returnCenters', 'classes', 'spaceTitle', 'disabled'],
  components: {
  	Input,
  	DatePicker,
  	Select,
  	Checkbox,
    Range,
    RangePopup,
  	TypeSearch,
  	CheckboxGroup,
    FeaturePopup
  },
  computed: {
    filterHasValue () {
      if ((this.$store.state.rent.category_id && this.$store.state.rent.category_id.length > 0) || (this.$store.state.rent.amenity_id && this.$store.state.rent.amenity_id.length > 0) || this.$store.state.rent.from_date || this.$store.state.rent.to_date || this.$store.state.rent.from_footfall || this.$store.state.rent.to_footfall || this.$store.state.rent.location_type || this.$store.state.rent.price || this.$store.state.rent.to_price || this.$store.state.rent.query) {
        return true
      } 
    },
  	returnDateRange () {
  		var dateRange = {
  			from: this.$store.state.rent.from_date ? this.$store.state.rent.from_date : null,
  			to: this.$store.state.rent.to_date ? this.$store.state.rent.to_date : null,
  		}
  		return dateRange
  	},
    returnPrice () {
      var price = {
        from: this.$store.state.rent.from_price ? this.$store.state.rent.from_price : 0,
        to: this.$store.state.rent.to_price ? this.$store.state.rent.to_price : 1000,
        data: [0, 200, 400, 600, 800, 1000],
        marks: true,
        max: 10000,
        min: 0,
		label: "Daily Rate(€)"
      }
      return price
    },
    returnFootfall () {
      var footfall = {
        from: this.$store.state.rent.from_footfall ? this.$store.state.rent.from_footfall : 0,
        to: this.$store.state.rent.to_footfall ? this.$store.state.rent.to_footfall : 16000000,
        marks: {
          '0': {
            label: '0k',
          },
          '2000000': {
            label: '2M',
          },
          '4000000': {
            label: '4M',
          },
          '6000000': {
            label: '6M',
          },
          '8000000': {
            label: '8M',
          },
          '10000000': {
            label: '10M',
          },
          '12000000': {
            label: '12M',
          },
          '14000000': {
            label: '14M',
          },
          '16000000': {
            label: '16M',
          }
        },
        max: 16000000,
        min: 0
      }
      return footfall
    },
  	returnPropertyType () {
  		var property_type = [{
    	id: 'shopping_centre',
    	label: this.$store.getters.language.shopping_centre,
    	checked: this.$store.state.rent.category_id && this.$store.state.rent.category_id.includes('Shopping Centre') ? true : false,
    	value: 'Shopping Centre',
     	name: 'property_type'
    }, {
    	id: 'supermarket',
    	label: this.$store.getters.language.supermarket,
    	checked: this.$store.state.rent.category_id && this.$store.state.rent.category_id.includes('Supermarket') ? true : false,
    	value: 'Supermarket',
      name: 'property_type'
    }, {
    	id: 'cinema',
    	label: this.$store.getters.language.cinema,
    	checked: this.$store.state.rent.category_id && this.$store.state.rent.category_id.includes('Cinema') ? true : false,
    	value: 'Cinema',
      name: 'property_type'
    }]
    return property_type
  	},
  	returnAmenity () {
      if (this.organisation_name == 'Fillit'){
  		var amenities = [{
    	id: 'popup',
    	label: this.$store.getters.language.POP_UP,
    	checked: this.$store.state.rent.amenity_id && this.$store.state.rent.amenity_id.includes(134) ? true : false,
    	name: 'amenities',
    	value: 134
    }, {
    	id: 'event',
    	label: this.$store.getters.language.EVENT,
    	checked: this.$store.state.rent.amenity_id && this.$store.state.rent.amenity_id.includes(135) ? true : false,
     	name: 'amenities',
    	value: 135
    }, {
    	id: 'promotion',
    	label: this.$store.getters.language.PROMOTION,
    	checked: this.$store.state.rent.amenity_id && this.$store.state.rent.amenity_id.includes(136) ? true : false,
     	name: 'amenities',
    	value: 136
    }, {
    	id: 'digital_display',
    	label: this.$store.getters.language.DIGITAL_SCREEN,
    	checked: this.$store.state.rent.amenity_id && this.$store.state.rent.amenity_id.includes(137) ? true : false,
     	name: 'amenities',
    	value: 137
    }, {
    	id: 'kiosk_stand',
    	label: this.$store.getters.language.KIOSK_STAND,
    	checked: this.$store.state.rent.amenity_id && this.$store.state.rent.amenity_id.includes(168) ? true : false,
     	name: 'amenities',
    	value: 168
    }]
      }
      if (this.organisation_name == 'Nhood'){
        var amenities = [{
          id: 'promotion',
          label: this.$store.getters.language.PROMOTION,
          checked: this.$store.state.rent.amenity_id && this.$store.state.rent.amenity_id.includes(136) ? true : false,
          name: 'amenities',
          value: 136
        },
          {
          id: 'digital_display',
          label: this.$store.getters.language.sampling,
          checked: this.$store.state.rent.amenity_id && this.$store.state.rent.amenity_id.includes(137) ? true : false,
          name: 'amenities',
          value: 133
        },
          {
          id: 'product_sale',
          label: this.$store.getters.language.Productsale,
          checked: this.$store.state.rent.amenity_id && this.$store.state.rent.amenity_id.includes(201) ? true : false,
          name: 'amenities',
          value: 201
        }, {
          id: 'vehicle_exhibition',
          label: this.$store.getters.language.Vehicleexhibition,
          checked: this.$store.state.rent.amenity_id && this.$store.state.rent.amenity_id.includes(202) ? true : false,
          name: 'amenities',
          value: 202
        }]
      }
    return amenities
  	},
    returnFeatures () {
      var features = [{
      id: 'tomas_de_corriente',
      label: 'Tomas de corriente',
      checked: this.$store.state.rent.feature_id && this.$store.state.rent.feature_id.includes('Tomas de corriente') ? true : false,
      name: 'features',
      value: 'Tomas de corriente'
    }, {
      id: 'iluminación',
      label: 'Iluminación',
      checked: this.$store.state.rent.feature_id && this.$store.state.rent.feature_id.includes('Iluminación') ? true : false,
      name: 'features',
      value: 'Iluminación'
    }, {
      id: 'wifi',
      label: 'WIFI',
      checked: this.$store.state.rent.feature_id && this.$store.state.rent.feature_id.includes('WIFI') ? true : false,
      name: 'features',
      value: 'WIFI'
    }, {
      id: 'suministro_de_agua',
      label: 'Suministro de agua',
      checked: this.$store.state.rent.feature_id && this.$store.state.rent.feature_id.includes('Suministro de agua') ? true : false,
      name: 'features',
      value: 'Suministro de agua'
    }, {
      id: 'suministro_de_drenaje',
      label: 'Suministro de drenaje',
      checked: this.$store.state.rent.feature_id && this.$store.state.rent.feature_id.includes('Suministro de drenaje') ? true : false,
      name: 'features',
      value: 'Suministro de drenaje'
    }]
    return features
    }
  },
  watch: {
    // Watch for state changes
    '$store.state.rent': {
      handler (state) {
        // this.filterHasValue()
      },
      deep: true
    }
  },
  mounted () {
  },
  created () {
  	var self = this
  	// self.returnPropertyType()
  	// self.returnAmenity()
    window.addEventListener('popstate', function (event) {
      if (event.state) {
  		// self.returnPropertyType()
  		// self.returnAmenity()
      }
    })
    this.getUser()
  },
  methods: {
    getUser() {
      var self = this
      axios
          .get('/api/searches/get_user')
          .then(response => {
            this.loaded = true
              this.organisation_name = response.data.organisation_name
          })
    },
  	resetFilters () {
	  	const reset = {
	      distance: null,
	      category_id: [],
	      amenity_id: [],
        feature_id: [],
	      from_date: null,
	      to_date: null,
	      from_price: null,
	      to_price: null,
	      from_footfall: null,
	      to_footfall: null,
        location_type: null,
	      bounds: {
	        latitude: this.$store.state.rent.bounds.latitude,
	        longitude: this.$store.state.rent.bounds.longitude,
	        latitude2: this.$store.state.rent.bounds.latitude2,
	        longitude2: this.$store.state.rent.bounds.longitude2,
	      }
	  	}
	  	this.$store.commit('reset', reset)
      this.$root.$emit('resetMap')
      this.$root.$emit('resetTypeSearch')

      var queryUrl = window.location.href.split('?')[0]
		  history.replaceState(queryUrl, null, queryUrl)
  	},
  	commitValue (value, field) {
  		this.$store.commit(field, value)
  	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";

.filter-bar {
	width: 230px;
	position: fixed;
	top: 0px;
	left: 0;
	bottom: 0;
	background: #FFFFFF;

  @include breakpoint(tablet-landscape) {
    width: 100%;
    position: absolute;
    transition: none;
  }
}

.filter-bar--breadcrumb {
  background: rgba(#FFFFFF, 0.4);
  backdrop-filter: blur(5px);
  position: absolute;
  top: 70px;
  left: 0;
  right: 0;
  z-index: 1003;
  padding: 16px 16px 24px 16px;
  @include responsive-text-size('Header--12--BOLD');
  white-space: nowrap;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 3px;

  @include breakpoint(tablet-landscape) {
    display: none;
  }

  li {
    list-style: none;
    padding-right: 3px;
    display: inline-block;
    a {
      color: $primary;
      @include ease-fast;
      &.router-link-exact-active {
        color: $primary-grey;
      }
    }

    svg {
      display: block;
      width: 3.5px;
      line-height: 0;
    }

    &:last-child {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  li {
    &:last-child {
      a.router-link-active {
        color: $primary-grey;
      }
    }
  }
}

.filter-bar--reset {
 	@include responsive-text-size('Header--12--BOLD');
 	margin-bottom: 24px;
 	display: block;
 	@include ease-fast;
  color: $grey;

  &.is--enabled {
    color: $primary-grey;
  }
 	&:hover {
 		color: $grey;
 	}
}

.filter-bar--separator {
    border-color: $divider-light;
    border-width: 1px 0 0 0;
    margin: 0 0 24px 0;
    display: block;
    border-style: solid;
}

.filter-bar--scroll {
	position: absolute;
	top: 99px;
	left: 0;
	right: 0;
	bottom: 0;
	padding: 24px 16px;
	overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  /* width */
  &::-webkit-scrollbar {
    // width: 2px;
    display: none;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent; 
  }
   
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: rgba($border-grey, 0.1);
    height: 40px; 
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: $border-grey; 
  }

  @include breakpoint(tablet-landscape) {
    top: 0px;
    padding: 24px 32px;
  }
}

.filter-bar--label {
	color: $primary-grey;
	@include responsive-text-size('Header--12--BOLD');
	margin-bottom: 8px;
  line-height: 1;
}

.filter-bar--input-group {
	padding-bottom: 16px;
 	display: block;
}

.filter-bar--input--two-up {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 0px;

  ::v-deep .input-wrapper:first-child input {
    border-right: 0;
    border-radius: 4px 0 0 4px;
  }

  ::v-deep .input-wrapper:last-child input {
    border-radius: 0 4px 4px 0;
  }

}

.filter-bar--input-group--disabled {

  .typesearch-wrapper, .filter-bar--input--two-up, .group-wrapper, .filter-bar--label {
    opacity: 0.3;
    pointer-events: none;
  }
}
</style>
